import React from "react";
import { teamLeagueInfoUrl, titleToSlug, uniqueId } from "../../utils/generalLiveCenter";
import { DateUtility } from "../../utils/dateUtility";
import GolfMatch from "./GolfMatch";


const GolfListTable = ({ data, index, sport = "golf",
  websiteBaseUrl,
  dataPath,
  dataClient, }) => {
  const HeadingTag = index === 0 ? "h1" : "h2";
  return (
    <div className="golf_block">
      <div className="golf_head">
        <a
          href={teamLeagueInfoUrl({
            dataClient,
            websiteBaseUrl,
            dataPath,
            category: "league",
            sport,
            name: titleToSlug(data?.nm),
            id: data?.id,
          })}
        >
          <HeadingTag>{`${data?.nm}`}</HeadingTag>

        </a>
      </div>
      <div className="golf_head_table">
        <div className="section_lft">
          {DateUtility?.formatTo12HourTime(data?.st)}
        </div>
        <ul className="section_rgt">
          <li>
            {data?.par && (
              <>
                <span className="rgt_text">{`Par: ${data?.par}`}</span>
              </>
            )}
          </li>
          <li>
            {data?.prs && (
              <>
                <span className="rgt_text">{`Prize Money: ${data?.prs}`}</span>
              </>
            )}
          </li>
        </ul>
      </div>
      <div className="global_table striped golf_listing_table">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Player</th>
              <th>P</th>
              <th>T</th>
              <th>R1</th>
              <th>R2</th>
              <th>R3</th>
              <th>R4</th>
              <th>STROKES</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data?.matches?.map((match, index) => (
              <GolfMatch data={match} count={index + 1} key={uniqueId(index)} websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath} sport={sport} dataClient={dataClient} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GolfListTable;
